export default "__VITE_ASSET__BxKGoi46__"